import { createAction } from "../../internals/app/AppUtils";
import CourseRepository from "../../internals/repository/CourseRepository";
import ServiceRepository from "../../internals/repository/ServiceRepository";

export const ModuleEvents = {
  SEARCH_CATEGORIES: "SEARCH_CATEGORIES",
  UPDATE_COURSE_CATEGORY: "UPDATE_COURSE_CATEGORY",
  CREATE_COURSE_CATEGORY: "CREATE_COURSE_CATEGORY",
  FETCH_COURSE_CATEGORIES: "FETCH_COURSE_CATEGORIES",
};

// const createAction =
//   (type, action = () => {}, meta) =>
//   (...args) => ({
//     type,
//     payload: action(...args),
//     meta,
//   });

const fetchCategories = createAction(
  ModuleEvents.FETCH_COURSE_CATEGORIES,
  async (shopId: string) => {
    const result = await CourseRepository.fetchCategories(shopId);
    return result;
  },
  { loading: true }
);

const searchCategories = createAction(
  ModuleEvents.SEARCH_CATEGORIES,
  async (data: any) => {
    return data;
  },
  { loading: true }
);

const createCourseCategory = createAction(
  ModuleEvents.CREATE_COURSE_CATEGORY,
  async (params: any) => {
    const result = await CourseRepository.createCourseCategory(params);
    return result;
  }
);

const updateCourseCategory = createAction(
  ModuleEvents.UPDATE_COURSE_CATEGORY,
  async (params: any) => {
    const result = await CourseRepository.updateCourseCategory(params);
    return result;
  }
);

const exportedFunction = {
  createCourseCategory,
  updateCourseCategory,
  fetchCategories,
  searchCategories,
};

export default exportedFunction;
